import React from 'react'
import Layout from '../Component/Layout/Layout'
import OtherServices from '../Component/Service/OtherServices'


const OtherService = () => {
  return (
    <Layout>
      <OtherServices />
    </Layout>
  );
};

export default OtherService;
